import { ucccOfdShipmentStatusHistoryResponse } from "../../hooks/react-query/linehaul/useUcccOfdHistory";

export const mockUcccOfdShipmentStatusHistory =
  ucccOfdShipmentStatusHistoryResponse.parse({
    shipmentId: 133001229,
    statusHistory: [
      {
        id: 101,
        currentSic: "EWR",
        status: "ENRT",
        locationId: 1,
        locationDetails: {
          state: "NJ",
          city: "Test Location",
          zipCode: "07001",
          locationSic: "EWR",
          timezone: "America/New_York",
          timezoneOffset: null,
        },
        statusStartDateUtc: "2025-09-29T17:04:00.000Z",
        statusEndDateUtc: null,
        createdById: "123",
        createdBy: "TEST USER",
        createdOn: "2024-01-07T16:00:00.000Z",
        modifiedById: null,
        modifiedBy: null,
        modifiedOn: null,
        reasonForDelay: null,
        reportedIssue: "This is a test note",
        isServiceFailure: true,
      },
      {
        id: 102,
        currentSic: "EWR",
        status: "CLOS",
        locationId: 2,
        locationDetails: {
          state: "NJ",
          city: "Newark",
          zipCode: "07001",
          locationSic: "EWR",
          timezone: "America/New_York",
          timezoneOffset: null,
        },
        statusStartDateUtc: "2025-09-23T12:00:00.000Z",
        statusEndDateUtc: "2025-09-23T13:00:00.000Z",
        createdById: "123",
        createdBy: "Jane Doe",
        createdOn: "2025-09-23T12:30:00.000Z",
        modifiedById: null,
        modifiedBy: null,
        modifiedOn: null,
        reasonForDelay: null,
        reportedIssue: null,
        isServiceFailure: false,
      },
    ],
  });
